import scoringRules from '@scoutgg/scoring-rules';
const rules = scoringRules('basket')

const BASKET_STATS = [
  'minutes', 'minutes_in_last_5', 'appearances', 'fantasy_points',
]
const POSITIONS = [
  'guard_point', 'guard_shooting', 'forward_small', 'forward_power', 'center',
]
const FIBA_AVERAGE_GOALS = 77
const FIBA_AVERAGE_PRICE = 8
const RULES_DICTIONARY = {
  TwoPointersMade: 'field_goal',
  ThreePointersMade: 'threepoint_goal',
  FreeThrowsMade: 'freethrow_goal',
  Rebounds: 'rebound',
  Assists: 'assist',
  Steals: 'steal',
  BlockedShots: 'block',
  Turnovers: 'turnover',
}

const NBA_PRICE_COEF = 3.5
const CBA_PRICE_COEF = 3.0
const GREEK_PRICE_COEF = 2.1
const EURO_PRICE_COEF = 2.2
const DEFAULT_PRICE_COEF = 2.5

function _getPriceCoefficient(league) {
  if(
    league.name.includes('NBA') ||
    league.name.includes('American Basketball League')
  ) {
    return NBA_PRICE_COEF
  } else if(
    league.name.includes('CBA') ||
    league.name.includes('Chinese Basketball')
  ) {
    return CBA_PRICE_COEF
  } else if(
    league.name.includes('Stoiximan') ||
    league.name.includes('Greek')
  ) {
    return GREEK_PRICE_COEF
  } else if(
    league.name.includes('Euroleague')
  ) {
    return EURO_PRICE_COEF
  } else {
    return DEFAULT_PRICE_COEF
  }
}

function _isTeamFactored(league) {
  return league.name.includes('FIBA World Cup')
}

function processLineup(players, prices) {
  for(let position of POSITIONS) {
    const line = players
      .filter(p => p.position === position)
      .filter(p => prices[p._id])
      .sort((p1, p2) => {
        return p2.stats.average_minutes - p1.stats.average_minutes
      })
      .slice(0, 3)
    const statuses = line.map(({ _id }) => !prices[_id].disabled)

    if(line.length === 2 && !statuses[0]) {
      line[0].stats.average_minutes = 0
      line[1].stats.average_minutes = 30
    }

    if(line.length === 3) {
      const statusesMask = statuses.reduce((mask, value, index) => {
        return mask + ~~value * Math.pow(2, index)
      }, 0)
      switch(statusesMask) {
        case 6: // First player out of 3 is injured
          line[0].stats.average_minutes = 0
          line[1].stats.average_minutes = 30
          line[2].stats.average_minutes = 18
          break
        case 5: // Second player out of 3 is injured
          line[0].stats.average_minutes += 5
          line[1].stats.average_minutes = 0
          line[2].stats.average_minutes += 6
          break
        case 3: // Third player out of 3 is injured
          line[0].stats.average_minutes += 1
          line[1].stats.average_minutes += 1
          line[2].stats.average_minutes = 0
      }
    }
  }

  return players.filter(p => p.stats).map(player => {
    player.stats.projected_fp = projectFPs(player.stats)
    return player
  })
}

function processPlayerStats(stats = {}, projections = {}) {
  stats = Object.assign({}, stats)
  for(let key of BASKET_STATS) {
    stats[key] = stats[key] || 0
  }
  for(const [key, v] of Object.entries(projections)) {
    stats[`proj_${key}`] = v
  }

  stats.average_minutes = (stats.minutes + stats.minutes_in_last_5) / 2
  stats.fp_per_minute = stats.fantasy_points / (stats.appearances || 1) /
    (stats.minutes || 1)

  return stats
}

function projectFPs(stats) {
  return stats.fp_per_minute * stats.average_minutes
}

const getXfpFromFantasyData = (fantasyData) => {
  return Object.values(RULES_DICTIONARY)
    .reduce((acc, prop) => acc + fantasyData[prop] * rules.points(prop), 0)
}

function makePrice({ player, price, stats, match, side, league }) {
  if(player.stats?.proj_fantasyPoints != null) {
    return Math.max(4.3, +(player.stats.proj_fantasyPoints / 3.5).toFixed(1))
  }

  let calculatedPrice

  if(_isTeamFactored(league)) {
    const teamFactor =
          ((parseFloat(match.expectedGoals[side]) / 2) + FIBA_AVERAGE_GOALS) /
          FIBA_AVERAGE_GOALS
    const matchPrice = price.prices[match]
    calculatedPrice = ((
      (matchPrice.factor || 1) *
        FIBA_AVERAGE_PRICE *
        (teamFactor || 1)
    ) || 0)
  } else {
    const coefficient = _getPriceCoefficient(league)
    calculatedPrice = player.stats?.projected_fp / coefficient
  }
  return (calculatedPrice >= 4.3 ? calculatedPrice : 4.3).toFixed(1)
}



function getXfpFromProjection(projection) {
  let result = 0
  for(let index in RULES_DICTIONARY) {
    result += projection[index] *
      rules.points(RULES_DICTIONARY[index])
  }

  return result !== 0 && result
}

export default {
  processLineup,
  processPlayerStats,
  makePrice,
  getXfpFromProjection,
  projectFPs,
};
